const getters = {
  showBagFlag: state => state.global.showBagFlag,
  showOrderFlag: state => state.global.showOrderFlag,
  showVipFlag: state => state.global.showVipFlag,
  loginDialogFlag: state => state.global.loginDialogFlag,
  token: state => state.global.token,
}
export default getters
